(function () {
    'use strict';

    angular.module('ib-header-module', [
        'ib-flight-module',
        'ib-tooltip-module',
        'ib-multipath-tooltip-component-module',
        'ib-user-tooltip-module',
        'ib-passengers-module',
        'ib-basket-module',
        'ib-discounts-module',
        'ib-login-header-module',
        'ib-user-info-module',
        'ib-choose-language-module'
    ]);
})();